import { render } from "./DuplicateHandler.vue?vue&type=template&id=cf15527a"
import script from "./DuplicateHandler.vue?vue&type=script&lang=js"
export * from "./DuplicateHandler.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__